// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, signInWithPhoneNumber, RecaptchaVerifier, GoogleAuthProvider, signInWithPopup } from "firebase/auth";


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCS57TNTMi-HQJWB7sMHoMqKd3E-ziYuRk",
  authDomain: "meowgarden-65a07.firebaseapp.com",
  projectId: "meowgarden-65a07",
  storageBucket: "meowgarden-65a07.firebasestorage.app",
  messagingSenderId: "491366783071",
  appId: "1:491366783071:web:64d60f9996e4f09f39e3ea",
  measurementId: "G-RNGWY4F2NM"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider, signInWithPopup, signInWithEmailAndPassword, signInWithPhoneNumber, RecaptchaVerifier }; 